var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet24DpFill1Wght300Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.31-180q-29.83 0-51.07-21.24Q60-222.48 60-252.31v-455.38q0-29.83 21.24-51.07Q102.48-780 132.31-780h695.38q29.83 0 51.07 21.24Q900-737.52 900-707.69v455.38q0 29.83-21.24 51.07Q857.52-180 827.69-180H132.31ZM230-240h500v-480H230v480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet24DpFill1Wght300Grad0Opsz24);
export default __webpack_public_path__ + "static/media/tablet_24dp_FILL1_wght300_GRAD0_opsz24.6768393e05c40f4e777aeccda068f599.svg";
export { ForwardRef as ReactComponent };